<template>
  <div>
    <el-table :data="scheduledMails" border size="small" style="width: 1581px">
      <el-table-column prop="expiredAt" label="开始定时" align="center" width="120">
        <template slot-scope="scope">
          {{
            scope.row.cycleType != 0
              ? $util.ms2ymdhm(Number(scope.row.startAt))
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column prop="expiredAt" label="结束定时" align="center" width="120">
        <template slot-scope="scope">
          {{
            scope.row.cycleType != 0
              ? $util.ms2ymdhm(Number(scope.row.endAt))
              : ""
          }}
        </template>
      </el-table-column>
      <el-table-column label="定时时间" align="center" width="140">
        <template slot-scope="scope">
          <span v-if="scope.row.cycleType == 0">
            {{ $util.ms2datetime(scope.row.expiredAt) }}
          </span>
          <span v-else-if="scope.row.cycleType == 1">
            每天{{ formatSimpleTime(parseInt(scope.row.cycle / 60)) }}:{{
              formatSimpleTime(parseInt(scope.row.cycle % 60))
            }}</span>
          <span v-else-if="scope.row.cycleType == 2">
            每周{{
              $util.number2ZhWeek(parseInt(scope.row.cycle / (24 * 60)) + 1)
            }}{{
              formatSimpleTime(parseInt((scope.row.cycle % (24 * 60)) / 60))
            }}:{{
              formatSimpleTime(parseInt((scope.row.cycle % (24 * 60)) % 60))
            }}
          </span>
          <span v-else-if="scope.row.cycleType == 3">
            每月{{ parseInt(scope.row.cycle / (24 * 60)) + 1 }}号{{
              formatSimpleTime(parseInt((scope.row.cycle % (24 * 60)) / 60))
            }}:{{
              formatSimpleTime(parseInt((scope.row.cycle % (24 * 60)) % 60))
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="expiredAt" label="将于何时发送" align="center" width="140">
        <template slot="header">
          <span>将于何时发送</span>
          <div>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">根据定时配置推测出来的时间</div>
              <span><i class="el-icon-question" style="font-size: 1.2em"></i></span>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.expiredAt) }}
        </template>
      </el-table-column>
      <el-table-column prop="template.mailTemplateName" label="创建人" align="center" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.creator }}
        </template>
      </el-table-column>
      <el-table-column prop="template.mailTemplateName" label="标题" align="center" width="190" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ scope.row.template.mailTemplates[0].title }}
        </template>
      </el-table-column>
      <el-table-column label="标题和正文" align="center" width="100">
        <template slot-scope="scope">
          <el-popover v-model="scope.row.isTitleAndContentEverBeingViewed" placement="right" trigger="hover" width="600">
            <div v-if="scope.row.isTitleAndContentEverBeingViewed">
              <MailTemplate :languageTemplates="scope.row.template.mailTemplates" readonly></MailTemplate>
            </div>
            <el-button slot="reference" size="small" icon="el-icon-view">查看</el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="props" label="附件" align="center" width="330" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-for="(item, index) in scope.row.props" :key="index">
            {{ attachments[item.id] }} x {{ item.num }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="收件人" align="center" width="140">
        <template slot-scope="scope">
          <div v-if="scope.row.isSelectPlayersByConditions">
            <span style="font-weight: bold">分区：</span>{{ scope.row.zoneId ? scope.row.zoneId : "全分区" }}
            <br />
            <span style="font-weight: bold">渠道：</span>{{ scope.row.channelId ? scope.row.channelId : "全渠道" }}
          </div>
          <div v-else-if="scope.row.uidList.length > 0">
            <span style="font-weight: bold"> uid：</span>
            <span v-if="scope.row.uidList.length == 1">{{
              scope.row.uidList[0]
            }}</span>
            <span v-else>
              <li v-for="item in scope.row.uidList" :key="item">{{ item }}</li>
            </span>
          </div>
          <div v-else-if="scope.row.tidList.length > 0">
            <span style="font-weight: bold"> tid：</span>
            <span v-if="scope.row.tidList.length == 1">{{
              scope.row.tidList[0]
            }}</span>
            <span v-else>
              <li v-for="item in scope.row.tidList" :key="item">{{ item }}</li>
            </span>
          </div>          
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200">
        <template slot-scope="scope">
          <el-button size="small" v-if="!$bizutil.isCustomerService()" icon="el-icon-edit"
            @click="openUpdateScheduledMailDialog(scope.row)">修改</el-button>
          <el-button type="danger" size="small" icon="el-icon-delete" v-if="
            !$bizutil.isCustomerService() ||
            scope.row.creator == $bizutil.getLoginUser().username
          " @click="delScheduledMail(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");

import MailTemplate from "@/pages/mail/components/MailTemplate";

export default {
  data() {
    return {
      scheduledMails: [], // 定时邮件列表

      attachments: {},
      cycleTypeEntries: {
        0: "单次",
        1: "每天",
        2: "每周",
        2: "每月",
      },
    };
  },

  components: {
    MailTemplate,
  },

  async created() {
    this.attachments = await this.$bizutil.loadAttachments(true);

    // 拉取邮件模板集合
    await this.loadScheduledMailList();
  },

  methods: {
    /**
     *打开“修改定时邮件”对话框
     */
    openUpdateScheduledMailDialog(entry) {
      this.$dialogutil.open("UpdateScheduledMailDialog", {
        closedCallback: () => {
          this.loadScheduledMailList();
        },
        data: { form: entry },
      });
    },

    /**
     * 查询定时邮件集合
     */
    async loadScheduledMailList() {
      // 清空表格数据
      this.scheduledMails = [];

      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${this.$util.getBackendApiBase()}/v1/admin/queryScheduledMails`,
          {},
          {
            headers: {
              token: this.$bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let tasks = resData.data.list || [];

      for (let task of tasks) {
        let props = JSON.parse(task.props);

        this.scheduledMails.push({
          id: task.id,
          mailTemplateId: task.mailTemplateId,
          zoneId: task.zoneId,
          channelId: task.channelId,
          isSelectPlayersByConditions: task.isSelectPlayersByConditions,
          uidList: task.uidList,
          tidList: task.tidList,
          props: props,
          expiredAt: task.expiredAt,
          cycleType: task.cycleType,
          cycle: task.cycle,
          startAt: task.startAt,
          endAt: task.endAt,
          template: {
            mailTemplateId: task.template.mailTemplateId,
            mailTemplateName: task.template.mailTemplateName,
            mailTemplates: task.template.mailTemplates,
            isAutoCreated: task.template.isAutoCreated,
          },
          creator: task.creator,
        });
      }

      // 排序
      this.scheduledMails.sort((x, y) => {
        return Number(y.expiredAt) - Number(x.expiredAt);
      });
    },
    formatSimpleTime(val) {
      let v = parseInt(val);
      if (v < 10) {
        return "0" + v;
      }
      return v;
    },
    // 删除定时邮件
    async delScheduledMail(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除定时邮件？`);

        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/delScheduledMails`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });
        for (let i = 0; i < this.scheduledMails.length; i++) {
          if (this.scheduledMails[i].id == entry.id) {
            this.scheduledMails.splice(i, 1);
            break;
          }
        }
      } catch (e) { }
    },
  },
};
</script>